// Actions
export const UPDATE_HISTORY = 'companyExperience/sessionHistory/UPDATE_HISTORY'

export const SET_PARENT_LOCATION = 'companyExperience/sessionHistory/SET_PARENT_LOCATION'
export const CLEAR_PARENT_LOCATION = 'companyExperience/sessionHistory/CLEAR_PARENT_LOCATION'

// Action creators
export const updateHistory = (location, action) => ({
  type: UPDATE_HISTORY,
  meta: { action },
  payload: {
    history: [location],
  },
})

export const setParentLocation = location => ({
  type: SET_PARENT_LOCATION,
  payload: {
    currentParent: typeof location === 'string' ? { pathname: location } : location,
  },
})

export const clearParentLocation = () => ({
  type: CLEAR_PARENT_LOCATION,
  payload: {
    currentParent: null,
  },
})

// Reducers
const defaultState = {
  history: [],
  currentParent: null,
}

const sessionHistory = (state = defaultState, { type, meta, payload }) => {
  switch (type) {
    case UPDATE_HISTORY:
      if (meta.action === 'PUSH')
        return {
          ...state,
          ...payload,
          history: [...state.history, ...payload.history],
        }

      if (meta.action === 'POP')
        return {
          ...state,
          ...payload,
          history: state.history.slice(0, -1),
        }

      if (meta.action === 'REPLACE')
        return {
          ...state,
          ...payload,
          history: [...state.history.slice(0, -1), ...payload.history],
        }

    case SET_PARENT_LOCATION:
    case CLEAR_PARENT_LOCATION:
      return { ...state, ...payload }

    default:
      return state
  }
}

export default sessionHistory
